/* ==========================================================================
   NOCTSX — Nocturne theme.js
   Vanilla, no dependencies. Everything is progressive: pages work without JS,
   JS layers on instant search, wishlist, ajax cart, variant picking, filters.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = Object.assign({
    moneyFormat: '{{amount}}0 IQD',
    routes: { root: '/', cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartGet: '/cart.js', search: '/search', suggest: '/search/suggest.json', wishlist: '/pages/wishlist', predictive: true },
    afterAdd: 'drawer',
    popular: [],
    collections: [],
    whatsapp: '',
    strings: {}
  }, window.NS_CONFIG || {});
  cfg.popular = (cfg.popular || []).map(function (s) { return String(s).trim(); }).filter(Boolean);

  var S = Object.assign({
    added: 'أُضيف للسلة',
    viewCart: 'عرض السلة',
    wishAdd: 'أُضيف للمفضلة',
    wishRemove: 'أُزيل من المفضلة',
    soldOut: 'نفد',
    unavailable: 'غير متوفر',
    addToCart: 'أضف للسلة',
    chooseOptions: 'اختر الخيارات',
    inStock: 'متوفر',
    lowStock: 'باقي {n} فقط',
    products: 'منتجات',
    collections: 'الأقسام',
    suggestions: 'اقتراحات',
    popular: 'بحث شائع',
    viewAll: 'عرض كل النتائج',
    noResults: 'ما لقينا شي يطابق',
    tryAgain: 'جرّب كلمة ثانية أو تصفح الأقسام',
    error: 'صار خطأ، حاول مرة ثانية',
    emptyWish: 'مفضلتك فارغة',
    emptyWishText: 'اضغط على القلب في أي منتج حتى يظهر هنا.',
    onlyLeft: 'باقي {n}',
    new: 'جديد'
  }, cfg.strings || {});

  /* ------------------------------------------------------------------ utils */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { el && el.addEventListener(ev, fn, o); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var f = cfg.moneyFormat || '{{amount}}';
    var n = (Number(cents) || 0) / 100;
    var grp = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var parts = n.toFixed(2).split('.');
    var ip = parts[0], dp = parts[1], nd = n.toFixed(0);
    var map = {
      amount: grp(ip, ',') + '.' + dp,
      amount_no_decimals: grp(nd, ','),
      amount_with_comma_separator: grp(ip, '.') + ',' + dp,
      amount_no_decimals_with_comma_separator: grp(nd, '.'),
      amount_with_apostrophe_separator: grp(ip, "'") + '.' + dp,
      amount_no_decimals_with_space_separator: grp(nd, ' '),
      amount_with_space_separator: grp(ip, ' ') + ',' + dp,
      amount_with_period_and_space_separator: grp(ip, ' ') + '.' + dp
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return map[k] !== undefined ? map[k] : map.amount; }).replace(/<[^>]+>/g, '');
  }

  function img(url, w) {
    if (!url) return '';
    if (typeof url === 'object') url = url.url || url.src || '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (!w) return url;
    if (/[?&]width=/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function getJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }, opts || {})).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'error'); e.data = j; throw e; } return j; });
    });
  }

  var lockCount = 0;
  function lock(onOff) {
    lockCount = Math.max(0, lockCount + (onOff ? 1 : -1));
    document.body.classList.toggle('is-locked', lockCount > 0);
  }

  /* scrim shared by sheet / drawers */
  var scrim = $('#ns-scrim');
  var scrimHandlers = [];
  function scrimOn(handler) { scrimHandlers.push(handler); scrim && scrim.classList.add('is-on'); }
  function scrimOff(handler) { scrimHandlers = scrimHandlers.filter(function (h) { return h !== handler; }); if (!scrimHandlers.length) scrim && scrim.classList.remove('is-on'); }
  on(scrim, 'click', function () { scrimHandlers.slice().forEach(function (h) { h(); }); });

  /* toast */
  var toastEl, toastT;
  function toast(o) {
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<div class="toast__in"></div>'; document.body.appendChild(toastEl);
    }
    var inner = $('.toast__in', toastEl);
    inner.innerHTML = (o.img ? '<img src="' + esc(img(o.img, 120)) + '" alt="">' : '<svg class="ic"><use href="#i-' + (o.icon || 'check') + '"></use></svg>') +
      '<span>' + esc(o.text) + '</span>' + (o.link ? '<a href="' + esc(o.link) + '">' + esc(o.linkText || '') + '</a>' : '');
    clearTimeout(toastT);
    toastEl.classList.add('is-on');
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, o.ms || 2600);
  }

  /* ------------------------------------------------------------------ theme */
  function setTheme(t, animate) {
    document.documentElement.setAttribute('data-theme', t);
    try { localStorage.setItem('ns-theme', t); } catch (e) { }
    var m = $('meta[name="theme-color"]'); if (m) m.setAttribute('content', t === 'dark' ? '#09090d' : '#f4f3ef');
    if (animate) $$('[data-theme-toggle]').forEach(function (b) { b.classList.remove('is-spin'); void b.offsetWidth; b.classList.add('is-spin'); });
  }
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-theme-toggle]'); if (!b) return;
    var next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    /* browser-native crossfade between the two themes where supported */
    if (document.startViewTransition && !reduced) document.startViewTransition(function () { setTheme(next, true); });
    else setTheme(next, true);
  });

  /* ------------------------------------------------------------------ header */
  var hdr = $('.hdr');
  if (hdr) {
    var lastY = 0, ticking = false;
    var onScroll = function () {
      var y = window.scrollY || 0;
      hdr.classList.toggle('is-scrolled', y > 8);
      lastY = y; ticking = false;
    };
    on(window, 'scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------------ wishlist */
  var Wish = {
    key: 'ns-wish',
    get: function () { try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (e) { return []; } },
    set: function (a) { try { localStorage.setItem(this.key, JSON.stringify(a.slice(0, 120))); } catch (e) { } this.paint(); },
    has: function (h) { return this.get().indexOf(h) > -1; },
    toggle: function (h) { var a = this.get(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); this.set(a); return i === -1; },
    paint: function () {
      var a = this.get(), n = a.length;
      $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', a.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false'); });
      $$('[data-wish-count]').forEach(function (c) { c.textContent = n; c.hidden = n === 0; });
      $$('[data-wish-dock]').forEach(function (b) { b.classList.toggle('is-full', n > 0); });
    }
  };
  on(document, 'click', function (e) {
    var b = e.target.closest('button[data-wish]'); if (!b) return;
    e.preventDefault();
    var added = Wish.toggle(b.getAttribute('data-wish'));
    var c = $$('[data-wish-count]')[0]; if (c) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
    toast({ text: added ? S.wishAdd : S.wishRemove, icon: 'heart', link: added ? cfg.routes.wishlist : '', linkText: 'المفضلة' });
    if (!added && b.closest('[data-wishlist-page]')) { var card = b.closest('.card'); if (card) { card.style.transition = 'opacity .25s'; card.style.opacity = '0'; setTimeout(function () { card.remove(); wishlistEmptyCheck(); }, 250); } }
  });

  /* ------------------------------------------------------------------ product card (JS twin of snippets/ns-card.liquid) */
  function normalize(p) {
    if (!p) return null;
    var fromPredictive = typeof p.price === 'string';
    var price = fromPredictive ? Math.round(parseFloat(p.price) * 100) : (p.price != null ? p.price : (p.price_min || 0));
    var cmpRaw = fromPredictive ? (p.compare_at_price_max || p.compare_at_price) : (p.compare_at_price != null ? p.compare_at_price : p.compare_at_price_max);
    var compare = cmpRaw ? (typeof cmpRaw === 'string' ? Math.round(parseFloat(cmpRaw) * 100) : cmpRaw) : null;
    var image = p.featured_image ? (p.featured_image.url || p.featured_image.src || p.featured_image) : (p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '');
    var image2 = p.images && p.images[1] ? (p.images[1].src || p.images[1]) : '';
    var variants = p.variants || [];
    var single = variants.length === 1 ? variants[0] : null;
    var handle = p.handle || (p.url ? p.url.split('?')[0].split('/').pop() : '');
    return {
      handle: handle, title: p.title || '', url: (p.url || ('/products/' + handle)).split('?')[0],
      image: image, image2: image2, price: price, compare: compare, available: p.available !== false,
      variantId: single ? single.id : null, multi: variants.length > 1, qty: single && single.inventory_quantity != null ? single.inventory_quantity : null
    };
  }

  function cardHTML(p, opts) {
    opts = opts || {};
    var sale = p.compare && p.compare > p.price;
    var pct = sale ? Math.round((1 - p.price / p.compare) * 100) : 0;
    var out = !p.available;
    var stock = out ? '<div class="card__stock card__stock--out">' + S.soldOut + '</div>' :
      (p.qty != null && p.qty > 0 && p.qty <= 3 ? '<div class="card__stock card__stock--low">' + S.lowStock.replace('{n}', p.qty) + '</div>' : '<div class="card__stock">' + S.inStock + '</div>');
    var add = out ? '' : (p.variantId && !p.multi ?
      '<form class="card__add" action="' + cfg.routes.cartAdd.replace('.js', '') + '" method="post" data-ajax-add><input type="hidden" name="id" value="' + p.variantId + '"><input type="hidden" name="quantity" value="1"><button class="add" type="submit" aria-label="' + S.addToCart + '"><svg class="ic"><use href="#i-plus"></use></svg><svg class="ic"><use href="#i-check"></use></svg></button></form>' :
      '<a class="add" href="' + esc(p.url) + '" aria-label="' + S.chooseOptions + '"><svg class="ic"><use href="#i-arrow"></use></svg></a>');
    return '<article class="card' + (out ? ' is-sold' : '') + (opts.cls ? ' ' + opts.cls : '') + '" data-handle="' + esc(p.handle) + '">' +
      '<div class="card__media"><a class="card__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
      '<img src="' + esc(img(p.image, 480)) + '" srcset="' + esc(img(p.image, 360)) + ' 360w, ' + esc(img(p.image, 600)) + ' 600w" sizes="(min-width:1000px) 280px, 50vw" alt="" loading="lazy" decoding="async" width="600" height="600">' +
      (p.image2 ? '<img class="card__img2" src="' + esc(img(p.image2, 480)) + '" alt="" loading="lazy" decoding="async" width="600" height="600">' : '') + '</a>' +
      '<div class="card__badges">' + (sale ? '<span class="badge badge--sale ltr">-' + pct + '%</span>' : '') + (out ? '<span class="badge badge--out">' + S.soldOut + '</span>' : '') + '</div>' +
      '<button class="heart" type="button" data-wish="' + esc(p.handle) + '" aria-label="المفضلة" aria-pressed="' + (Wish.has(p.handle) ? 'true' : 'false') + '"><svg class="ic"><use href="#i-heart"></use></svg></button></div>' +
      '<div class="card__body"><h3 class="card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
      '<div class="card__foot"><div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now ltr">' + money(p.price) + '</span>' + (sale ? '<s class="price__was ltr">' + money(p.compare) + '</s>' : '') + '</div>' + add + '</div>' + stock + '</div></article>';
  }

  /* ------------------------------------------------------------------ cart */
  var Cart = {
    drawer: $('[data-cart-drawer]'),
    busy: false,
    open: function (refresh) {
      var d = this.drawer; if (!d) { location.href = cfg.routes.cart; return; }
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lock(true); scrimOn(Cart.closeBound);
      if (refresh !== false) this.refresh();
      setTimeout(function () { var f = $('.drawer__h button', d); f && f.focus(); }, 50);
    },
    close: function () { var d = Cart.drawer; if (!d || !d.classList.contains('is-open')) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lock(false); scrimOff(Cart.closeBound); },
    refresh: function () {
      var d = this.drawer; if (!d) return Promise.resolve();
      return fetch(cfg.routes.root + '?sections=ns-cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); }).then(function (j) { Cart.swap(j); }).catch(function () { });
    },
    swap: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-section-swap]', doc);
        var cur = $('[data-section-id="' + id + '"] [data-section-swap], #shopify-section-' + id + ' [data-section-swap]');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; init(cur); }
        var count = $('[data-cart-total-count]', doc);
        if (count) Cart.paintCount(parseInt(count.getAttribute('data-cart-total-count'), 10) || 0);
      });
    },
    paintCount: function (n) {
      $$('[data-cart-count]').forEach(function (c) { var was = c.textContent; c.textContent = n; c.hidden = n === 0; if (was !== String(n)) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); } });
      $$('[data-cart-fab]').forEach(function (f) { f.hidden = n === 0; });
    },
    sectionIds: function () {
      var ids = ['ns-cart-drawer'];
      var page = $('[data-cart-page]'); if (page) ids.push(page.getAttribute('data-section-id'));
      return ids.join(',');
    },
    add: function (body, btn, meta) {
      if (Cart.busy) return; Cart.busy = true;
      btn && btn.classList.add(btn.classList.contains('add') ? 'is-busy' : 'btn--loading');
      body.sections = Cart.sectionIds(); body.sections_url = location.pathname;
      return getJSON(cfg.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) {
          Cart.swap(res.sections);
          if (btn && btn.classList.contains('add')) { btn.classList.add('is-ok'); setTimeout(function () { btn.classList.remove('is-ok'); }, 1600); }
          if (cfg.afterAdd === 'drawer' && Cart.drawer) Cart.open(false);
          else toast({ text: S.added, img: (res.items ? res.items[0] : res).image || (meta && meta.image), link: cfg.routes.cart, linkText: S.viewCart });
        })
        .catch(function (e) { toast({ text: e.message || S.error, icon: 'alert', ms: 3500 }); })
        .then(function () { Cart.busy = false; btn && btn.classList.remove('btn--loading', 'is-busy'); });
    },
    change: function (key, qty, lineEl) {
      lineEl && lineEl.classList.add('is-busy');
      return getJSON(cfg.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty, sections: Cart.sectionIds(), sections_url: location.pathname }) })
        .then(function (res) { Cart.swap(res.sections); })
        .catch(function (e) { toast({ text: e.message || S.error, icon: 'alert' }); lineEl && lineEl.classList.remove('is-busy'); });
    }
  };
  Cart.closeBound = function () { Cart.close(); };
  on(document, 'click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('[data-cart-close]')) { Cart.close(); return; }
    var q = t.closest('[data-qty]');
    if (q) {
      var line = q.closest('[data-line-key]'); var input = $('input', q.parentNode);
      var n = Math.max(0, (parseInt(input.value, 10) || 0) + (q.getAttribute('data-qty') === '+' ? 1 : -1));
      input.value = n;
      if (line) Cart.change(line.getAttribute('data-line-key'), n, line);
      return;
    }
    var rm = t.closest('[data-remove]');
    if (rm) { e.preventDefault(); var l = rm.closest('[data-line-key]'); Cart.change(l.getAttribute('data-line-key'), 0, l); }
  });
  on(document, 'change', function (e) {
    var input = e.target.closest('[data-line-key] .stepper input'); if (!input) return;
    var line = input.closest('[data-line-key]'); Cart.change(line.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0), line);
  });
  on(document, 'submit', function (e) {
    var f = e.target.closest('form[data-ajax-add]'); if (!f) return;
    e.preventDefault();
    var fd = new FormData(f), body = { items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1 }] };
    var props = {}; fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    if (Object.keys(props).length) body.items[0].properties = props;
    Cart.add(body, $('button[type="submit"]', f), { image: f.getAttribute('data-image') });
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') { Cart.close(); Search.close(); Filters.close(); Menu.close(); } });

  /* ------------------------------------------------------------------ mobile menu (glass panel under the header) */
  var Menu = {
    open: function () {
      var m = $('[data-menu]'), b = $('[data-menu-toggle]'); if (!m || m.classList.contains('is-open')) return;
      m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); b && (b.classList.add('is-open'), b.setAttribute('aria-expanded', 'true')); lock(true); scrimOn(Menu.closeBound);
    },
    close: function () {
      var m = $('[data-menu].is-open'), b = $('[data-menu-toggle]'); if (!m) return;
      m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); b && (b.classList.remove('is-open'), b.setAttribute('aria-expanded', 'false')); lock(false); scrimOff(Menu.closeBound);
    }
  };
  Menu.closeBound = function () { Menu.close(); };
  on(document, 'click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) { $('[data-menu].is-open') ? Menu.close() : Menu.open(); return; }
    if (e.target.closest('[data-menu] a')) Menu.close();
  });
  if (Cart.drawer) getJSON(cfg.routes.cartGet).then(function (c) { Cart.paintCount(c.item_count); }).catch(function () { });

  /* ------------------------------------------------------------------ search (dock) */
  var Search = {
    input: $('[data-dock-search] input'), form: $('[data-dock-search]'), sheet: $('[data-sheet]'), clear: $('[data-dock-clear]'),
    open: false, cache: {}, ctrl: null, active: -1,
    init: function () {
      var s = this; if (!s.input || !s.sheet) return;
      s.scroll = $('.sheet__scroll', s.sheet);
      on(s.input, 'focus', function () { s.show(); });
      on(s.input, 'click', function () { s.show(); });
      on(s.input, 'input', function () { s.clear.hidden = !s.input.value; s.query(s.input.value); });
      on(s.clear, 'click', function () { s.input.value = ''; s.clear.hidden = true; s.input.focus(); s.query(''); });
      on(s.form, 'submit', function (e) { if (!s.input.value.trim()) { e.preventDefault(); s.input.focus(); } else s.remember(s.input.value); });
      on(s.sheet, 'click', function (e) {
        if (e.target.closest('.sr')) s.remember(s.input.value);
        var clr = e.target.closest('[data-recent-clear]'); if (clr) { e.preventDefault(); try { localStorage.removeItem('ns-recent-q'); } catch (x) { } s.render(s.initialHTML()); }
      });
      /* rotating placeholder hints while the field is idle */
      if (cfg.popular.length > 1 && !reduced) {
        var base = s.input.getAttribute('placeholder') || '', k = 0;
        setInterval(function () { if (document.activeElement === s.input || s.input.value) return; k = (k + 1) % (cfg.popular.length + 1); s.input.setAttribute('placeholder', k === 0 ? base : 'ابحث عن ' + cfg.popular[k - 1] + '…'); }, 2800);
      }
      on(s.input, 'keydown', function (e) {
        var rows = $$('.sr', s.sheet); if (!rows.length) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault(); s.active = (s.active + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
          rows.forEach(function (r, i) { r.classList.toggle('is-active', i === s.active); }); rows[s.active].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && s.active > -1) { e.preventDefault(); location.href = rows[s.active].getAttribute('href'); }
      });
      s.query('');
    },
    show: function () {
      if (this.open) return; this.open = true;
      this.sheet.classList.add('is-open'); this.sheet.setAttribute('aria-hidden', 'false');
      scrimOn(Search.closeBound); $$('[data-dock-home]').forEach(function (b) { b.classList.remove('is-on'); });
    },
    close: function () {
      if (!this.open) return; this.open = false; this.active = -1;
      this.sheet.classList.remove('is-open'); this.sheet.setAttribute('aria-hidden', 'true');
      scrimOff(Search.closeBound); this.input && this.input.blur();
    },
    query: debounce(function (q) { Search.run(q); }, 180),
    run: function (q) {
      var s = this; q = (q || '').trim(); s.active = -1;
      if (q.length < 2) { s.render(s.initialHTML()); return; }
      if (s.cache[q]) { s.render(s.cache[q]); return; }
      if (s.ctrl) s.ctrl.abort(); s.ctrl = window.AbortController ? new AbortController() : null;
      s.render('<div class="skel"></div><div class="skel"></div><div class="skel"></div>');
      var url = cfg.routes.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      var req = cfg.routes.predictive ? getJSON(url, { signal: s.ctrl && s.ctrl.signal }).then(function (j) { return j.resources.results; }) : Promise.reject(new Error('off'));
      req.catch(function (e) {
        if (e.name === 'AbortError') throw e;
        return getJSON(cfg.routes.search + '?view=ns&type=product&q=' + encodeURIComponent(q), { signal: s.ctrl && s.ctrl.signal }).then(function (j) { return { products: j.products || [], collections: [], queries: [] }; });
      }).then(function (r) {
        var html = s.resultsHTML(q, r); s.cache[q] = html; if (s.input.value.trim() === q) s.render(html);
      }).catch(function (e) { if (e.name !== 'AbortError') s.render('<div class="sheet__empty"><svg class="ic"><use href="#i-alert"></use></svg><b>' + S.error + '</b></div>'); });
    },
    render: function (html) { if (this.scroll) this.scroll.innerHTML = html; },
    recent: function () { try { return JSON.parse(localStorage.getItem('ns-recent-q') || '[]'); } catch (e) { return []; } },
    remember: function (q) {
      q = (q || '').trim(); if (q.length < 2) return;
      var a = this.recent().filter(function (x) { return x !== q; }); a.unshift(q);
      try { localStorage.setItem('ns-recent-q', JSON.stringify(a.slice(0, 6))); } catch (e) { }
    },
    initialHTML: function () {
      var h = '', rec = this.recent();
      if (rec.length) h += '<div class="sheet__group"><div class="sheet__h"><span>بحثت مؤخراً</span><a href="#" data-recent-clear>مسح</a></div><div class="chips">' + rec.map(function (p) { return '<a class="chip" href="' + cfg.routes.search + '?q=' + encodeURIComponent(p) + '&type=product"><svg class="ic"><use href="#i-search"></use></svg>' + esc(p) + '</a>'; }).join('') + '</div></div>';
      if (cfg.popular.length) h += '<div class="sheet__group"><div class="sheet__h">' + S.popular + '</div><div class="chips">' + cfg.popular.map(function (p) { return '<a class="chip" href="' + cfg.routes.search + '?q=' + encodeURIComponent(p) + '&type=product"><svg class="ic"><use href="#i-search"></use></svg>' + esc(p) + '</a>'; }).join('') + '</div></div>';
      if (cfg.collections.length) h += '<div class="sheet__group"><div class="sheet__h">' + S.collections + '</div><div class="chips">' + cfg.collections.map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div></div>';
      return h || '<div class="sheet__empty"><svg class="ic"><use href="#i-search"></use></svg><b>ابحث عن أي منتج</b></div>';
    },
    resultsHTML: function (q, r) {
      var s = this, h = '';
      var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      var hl = function (t) { return esc(t).replace(re, '<mark>$1</mark>'); };
      var prods = (r.products || []).map(normalize).filter(Boolean);
      if (prods.length) {
        h += '<div class="sheet__group"><div class="sheet__h"><span>' + S.products + '</span><a href="' + cfg.routes.search + '?q=' + encodeURIComponent(q) + '">' + S.viewAll + '</a></div>';
        h += prods.map(function (p) {
          var sale = p.compare && p.compare > p.price;
          return '<a class="sr" href="' + esc(p.url) + '"><img class="sr__img" src="' + esc(img(p.image, 160)) + '" alt="" loading="lazy" width="56" height="56">' +
            '<div class="sr__body"><div class="sr__title">' + hl(p.title) + '</div><div class="sr__meta"><span class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now ltr">' + money(p.price) + '</span>' + (sale ? '<s class="price__was ltr">' + money(p.compare) + '</s>' : '') + '</span>' +
            '<i class="sr__dot' + (p.available ? '' : ' sr__dot--out') + '"></i><span>' + (p.available ? S.inStock : S.soldOut) + '</span></div></div><svg class="ic"><use href="#i-arrow"></use></svg></a>';
        }).join('') + '</div>';
      }
      if (r.collections && r.collections.length) h += '<div class="sheet__group"><div class="sheet__h">' + S.collections + '</div><div class="chips">' + r.collections.map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + hl(c.title) + '</a>'; }).join('') + '</div></div>';
      if (r.queries && r.queries.length) h += '<div class="sheet__group"><div class="sheet__h">' + S.suggestions + '</div><div class="chips">' + r.queries.map(function (x) { return '<a class="chip" href="' + esc(x.url) + '"><svg class="ic"><use href="#i-search"></use></svg>' + esc(x.text) + '</a>'; }).join('') + '</div></div>';
      if (!h) h = '<div class="sheet__empty"><svg class="ic"><use href="#i-search"></use></svg><b>' + S.noResults + ' «' + esc(q) + '»</b><span>' + S.tryAgain + '</span></div>' + (cfg.collections.length ? '<div class="chips" style="justify-content:center">' + cfg.collections.slice(0, 6).map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>' : '');
      return h;
    }
  };
  Search.closeBound = function () { Search.close(); };
  Search.init();

  /* dock: mark current page (the wishlist may live at /search?view=wishlist, so compare the view param too) */
  (function () {
    var path = location.pathname.replace(/\/$/, '') || '/';
    var view = new URLSearchParams(location.search).get('view') || '';
    $$('.dock__btn[href]').forEach(function (a) {
      var u; try { u = new URL(a.getAttribute('href'), location.origin); } catch (e) { return; }
      var hp = u.pathname.replace(/\/$/, '') || '/';
      if (hp === path && (u.searchParams.get('view') || '') === view) a.classList.add('is-on');
    });
  })();

  /* ------------------------------------------------------------------ filters drawer (collection) */
  /* resolved lazily: the collection section is re-rendered by ajax filtering, so the element changes */
  var Filters = {
    open: function () { var el = $('[data-filters]'); if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lock(true); scrimOn(Filters.closeBound); },
    close: function () { var el = $('[data-filters].is-open'); if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lock(false); scrimOff(Filters.closeBound); }
  };
  Filters.closeBound = function () { Filters.close(); };
  on(document, 'click', function (e) {
    if (e.target.closest('[data-filters-open]')) { e.preventDefault(); Filters.open(); }
    if (e.target.closest('[data-filters-close]')) { Filters.close(); }
  });

  /* ------------------------------------------------------------------ per-root initialisers */
  function initReveal(root) {
    var els = $$('[data-reveal]:not(.in)', root); if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (e, i) { e.style.transitionDelay = Math.min(i % 8, 6) * 40 + 'ms'; io.observe(e); });
  }

  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (wrap) {
      if (wrap.__tabs) return; wrap.__tabs = true;
      var tabs = $$('[role="tab"]', wrap), panels = $$('[role="tabpanel"]', wrap);
      var go = function (i) {
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
        tabs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduced ? 'auto' : 'smooth' });
        initReveal(panels[i]);
      };
      tabs.forEach(function (t, i) { on(t, 'click', function () { go(i); }); });
    });
  }

  function initReels(root) {
    var vids = $$('.reel video', root); if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target, reel = v.closest('.reel');
        if (en.intersectionRatio > 0.6 && !reel.classList.contains('is-paused')) { var p = v.play(); if (p && p.catch) p.catch(function () { }); reel.classList.add('is-playing'); }
        else { v.pause(); }
      });
    }, { threshold: [0, 0.6, 1] });
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); io.observe(v); });
    $$('.reel__play', root).forEach(function (b) {
      on(b, 'click', function () {
        var reel = b.closest('.reel'), v = $('video', reel);
        if (v.paused) { reel.classList.remove('is-paused'); v.play(); reel.classList.add('is-playing'); }
        else { reel.classList.add('is-paused'); v.pause(); }
      });
    });
  }

  /* product page */
  function initProduct(root) {
    $$('[data-product]', root).forEach(function (el) {
      if (el.__init) return; el.__init = true;
      var data = $('[data-product-json]', el); if (!data) return;
      var product = JSON.parse(data.textContent);
      var form = $('form[data-product-form]', el);
      var idInput = form && $('input[name="id"]', form);
      var priceNow = $('[data-price]', el), priceWas = $('[data-compare]', el), priceWrap = $('[data-price-wrap]', el);
      var stock = $('[data-stock]', el), btn = $('[data-add-btn]', el), btnText = btn && $('span', btn);
      var stickyPrice = $('[data-sticky-price]', el), stickyBtn = $('[data-sticky-add]', el);
      var badgeSale = $('[data-badge-sale]', el);
      var gal = $('[data-gallery]', el), dots = $$('[data-gallery-dots] i', el), thumbs = $$('[data-thumb]', el);
      var items = gal ? $$('.gal__it', gal) : [];

      function selected() {
        return $$('[data-option-index]', el).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
      }
      function findVariant(opts) {
        return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
      }
      function paintAvailability(opts) {
        /* grey out option values that would produce an unavailable variant given other selections */
        $$('[data-option-index]', el).forEach(function (g, gi) {
          $$('.pill', g).forEach(function (pill) {
            var val = $('input', pill).value;
            var test = opts.slice(); test[gi] = val;
            var v = findVariant(test);
            pill.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }
      function scrollToMedia(mediaId) {
        if (!gal || !mediaId) return;
        var i = items.findIndex(function (it) { return it.getAttribute('data-media-id') === String(mediaId); });
        if (i > -1) gal.scrollTo({ left: items[i].offsetLeft - gal.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      }
      function update(v, first) {
        if (!v) {
          if (btn) { btn.disabled = true; btnText && (btnText.textContent = S.unavailable); }
          if (stock) { stock.textContent = S.unavailable; stock.className = 'pdp__stock pdp__stock--out'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.textContent = sale ? money(v.compare_at_price) : ''; priceWas.hidden = !sale; }
        if (priceWrap) priceWrap.classList.toggle('price--sale', !!sale);
        if (badgeSale) { badgeSale.hidden = !sale; if (sale) badgeSale.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (btn) { btn.disabled = !v.available; btnText && (btnText.textContent = v.available ? S.addToCart : S.soldOut); }
        if (stickyBtn) { stickyBtn.disabled = !v.available; $('span', stickyBtn) && ($('span', stickyBtn).textContent = v.available ? S.addToCart : S.soldOut); }
        if (stock) {
          var q = v.inventory_quantity, managed = v.inventory_management;
          if (!v.available) { stock.textContent = S.soldOut; stock.className = 'pdp__stock pdp__stock--out'; }
          else if (managed && q != null && q > 0 && q <= 5) { stock.textContent = S.lowStock.replace('{n}', q); stock.className = 'pdp__stock pdp__stock--low'; }
          else { stock.textContent = S.inStock; stock.className = 'pdp__stock'; }
        }
        var waLink = $('[data-wa-stock]', el); if (waLink) waLink.hidden = v.available;
        if (!first && v.featured_media) scrollToMedia(v.featured_media.id);
        if (!first && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      }
      on(el, 'change', function (e) {
        if (!e.target.closest('[data-option-index]')) return;
        var opts = selected(); paintAvailability(opts); update(findVariant(opts));
      });
      var cur = product.variants.filter(function (v) { return idInput && String(v.id) === String(idInput.value); })[0] || product.variants[0];
      if ($$('[data-option-index]', el).length) paintAvailability(selected());
      update(cur, true);

      /* gallery dots + thumbs */
      if (gal && items.length > 1) {
        var setActive = function () {
          var i = Math.round(gal.scrollLeft / gal.clientWidth); i = Math.abs(i);
          if (i >= items.length) i = items.length - 1;
          dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
          thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        };
        var raf = false; on(gal, 'scroll', function () { if (!raf) { raf = true; requestAnimationFrame(function () { setActive(); raf = false; }); } }, { passive: true });
        thumbs.forEach(function (t, k) { on(t, 'click', function () { gal.scrollTo({ left: items[k].offsetLeft - gal.offsetLeft, behavior: reduced ? 'auto' : 'smooth' }); }); });
        setActive();
      }

      /* quantity */
      on(el, 'click', function (e) {
        var b = e.target.closest('[data-pqty]'); if (!b) return;
        var input = $('input', b.parentNode); var n = Math.max(1, (parseInt(input.value, 10) || 1) + (b.getAttribute('data-pqty') === '+' ? 1 : -1)); input.value = n;
      });

      /* sticky buy bar */
      var sticky = $('[data-sticky-buy]', el), buy = $('[data-buy-anchor]', el);
      if (sticky && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-on', show); document.body.classList.toggle('has-sticky-buy', show); }, { threshold: 0 }).observe(buy);
        on(stickyBtn, 'click', function () { if (form) form.requestSubmit ? form.requestSubmit() : $('[data-add-btn]', form).click(); });
      }

      /* recommendations */
      var rec = $('[data-recommendations]', el.parentNode) || $('[data-recommendations]');
      if (rec && !rec.__done) {
        rec.__done = true;
        fetch(rec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'); var fresh = $('[data-recommendations]', doc);
          if (fresh && $('.card', fresh)) { rec.innerHTML = fresh.innerHTML; rec.hidden = false; init(rec); } else rec.remove();
        }).catch(function () { rec.remove(); });
      }
    });
  }

  /* collection ajax filtering + sorting */
  function initCollection(root) {
    $$('[data-collection]', root).forEach(function (el) {
      if (el.__init) return; el.__init = true;
      var id = el.getAttribute('data-section-id');
      var form = $('form[data-filter-form]', el), sort = $('[data-sort]', el), grid = $('[data-grid]', el);
      var load = function (url, push) {
        grid && grid.classList.add('is-loading');
        var u = new URL(url, location.origin); u.searchParams.set('section_id', id);
        fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'); var fresh = $('[data-collection]', doc);
          if (!fresh) { location.href = url; return; }
          el.innerHTML = fresh.innerHTML; el.__init = false; init(el);
          if (push !== false) history.pushState({ ns: url }, '', url);
          var top = el.getBoundingClientRect().top + window.scrollY - 70; if (window.scrollY > top) window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
        }).catch(function () { location.href = url; });
      };
      var build = function () {
        /* keep unrelated params (q, type…), drop the ones this form controls, then rebuild from the form + sort */
        var u = new URL(location.href);
        Array.prototype.slice.call(u.searchParams.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0 || k === 'sort_by' || k === 'page' || k === 'section_id') u.searchParams.delete(k); });
        if (form) { var fd = new FormData(form); fd.forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); }); }
        if (sort && sort.value) u.searchParams.set('sort_by', sort.value);
        return u.pathname + (u.search || '');
      };
      on(sort, 'change', function () { load(build()); });
      if (form) {
        on(form, 'change', debounce(function () { load(build()); }, 250));
        on(form, 'submit', function (e) { e.preventDefault(); load(build()); Filters.close(); });
      }
      on(el, 'click', function (e) {
        var a = e.target.closest('a[data-ajax-link]'); if (!a) return; e.preventDefault(); load(a.getAttribute('href'));
      });
    });
    if (!window.__nsPop) { window.__nsPop = true; on(window, 'popstate', function () { if ($('[data-collection]')) location.reload(); }); }
  }

  /* wishlist page */
  function wishlistEmptyCheck() {
    var page = $('[data-wishlist-page]'); if (!page) return;
    var grid = $('[data-grid]', page), empty = $('[data-empty]', page);
    var n = $$('.card', grid).length; empty.hidden = n > 0; grid.hidden = n === 0;
    var clear = $('[data-wish-clear]', page); if (clear) clear.hidden = n === 0;
  }
  function initWishlistPage(root) {
    var page = $('[data-wishlist-page]', root); if (!page || page.__init) return; page.__init = true;
    var grid = $('[data-grid]', page), handles = Wish.get();
    on($('[data-wish-clear]', page), 'click', function () { Wish.set([]); grid.innerHTML = ''; wishlistEmptyCheck(); });
    if (!handles.length) { wishlistEmptyCheck(); return; }
    grid.innerHTML = handles.map(function () { return '<div class="skel" style="aspect-ratio:1/1.45"></div>'; }).join('');
    Promise.all(handles.map(function (h) { return getJSON('/products/' + h + '.js').then(normalize).catch(function () { return null; }); })).then(function (list) {
      var keep = [];
      grid.innerHTML = list.map(function (p, i) { if (!p) return ''; keep.push(handles[i]); return cardHTML(p); }).join('');
      if (keep.length !== handles.length) Wish.set(keep);
      wishlistEmptyCheck(); init(grid);
    });
  }

  /* ------------------------------------------------------------------ polish: image fade-in, to-top, zoom, recently viewed, wishlist add-all */
  function initImages(root) {
    $$('.card__img img', root).forEach(function (im) { if (im.complete && im.naturalWidth) im.classList.add('is-loaded'); });
  }
  on(document, 'load', function (e) { var t = e.target; if (t && t.tagName === 'IMG') t.classList.add('is-loaded'); }, true);
  on(document, 'error', function (e) { var t = e.target; if (t && t.tagName === 'IMG') t.classList.add('is-loaded'); }, true);

  var totop = $('[data-totop]');
  if (totop) {
    var tt = false;
    on(window, 'scroll', function () { if (!tt) { tt = true; requestAnimationFrame(function () { totop.classList.toggle('is-on', window.scrollY > 900); tt = false; }); } }, { passive: true });
    on(totop, 'click', function () { window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); });
  }

  var zoomEl;
  function zoomOpen(src) {
    if (!zoomEl) {
      zoomEl = document.createElement('div'); zoomEl.className = 'zoom'; zoomEl.innerHTML = '<img alt=""><button class="zoom__close" type="button" aria-label="إغلاق"><svg class="ic"><use href="#i-close"></use></svg></button>';
      document.body.appendChild(zoomEl);
      on(zoomEl, 'click', function () { zoomEl.classList.remove('is-on'); lock(false); });
    }
    $('img', zoomEl).src = src; zoomEl.classList.add('is-on'); lock(true);
  }
  on(document, 'click', function (e) {
    var im = e.target.closest('.gal__it img'); if (!im) return;
    var src = im.currentSrc || im.src; zoomOpen(img(src.replace(/([?&])width=\d+/, '$1width=1600'), 1600));
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape' && zoomEl && zoomEl.classList.contains('is-on')) { zoomEl.classList.remove('is-on'); lock(false); } });

  var Recent = {
    key: 'ns-recent',
    get: function () { try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (e) { return []; } },
    add: function (h) { if (!h) return; var a = this.get().filter(function (x) { return x !== h; }); a.unshift(h); try { localStorage.setItem(this.key, JSON.stringify(a.slice(0, 12))); } catch (e) { } }
  };
  function initRecent(root) {
    var box = $('[data-recent]', root); if (!box || box.__init) return; box.__init = true;
    var cur = $('[data-product]'); var handle = cur && cur.getAttribute('data-handle');
    var list = Recent.get().filter(function (h) { return h !== handle; }).slice(0, 8);
    if (handle) Recent.add(handle);
    if (!list.length) return;
    Promise.all(list.map(function (h) { return getJSON('/products/' + h + '.js').then(normalize).catch(function () { return null; }); })).then(function (ps) {
      ps = ps.filter(Boolean); if (!ps.length) return;
      $('[data-grid]', box).innerHTML = ps.map(function (p) { return cardHTML(p, { cls: 'card--rail' }); }).join('');
      box.hidden = false; init(box);
    });
  }

  on(document, 'click', function (e) {
    var b = e.target.closest('[data-wish-add-all]'); if (!b) return;
    var ids = $$('[data-wishlist-page] form[data-ajax-add] input[name="id"]').map(function (i) { return parseInt(i.value, 10); });
    if (!ids.length) { toast({ text: 'ما في منتجات جاهزة للإضافة', icon: 'alert' }); return; }
    Cart.add({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }, b);
  });

  /* ------------------------------------------------------------------ interactive hero (floating gallery)
     pointer / finger / gyroscope / scroll parallax with depth per card, 3D tilt on the hovered card,
     a light that follows the cursor, and colour dots for the ambience. Everything is transform-only. */
  function initFloat(root) {
    $$('[data-float]', root).forEach(function (st) {
      if (st.__init) return; st.__init = true;
      var items = $$('.float__item', st), amb = $('.float__amb', st), cur = $('.float__cursor', st);
      var tx = 0, ty = 0, cx = 0, cy = 0, sc = 0, hover = null, hx = 0, hy = 0, running = false, touch = window.matchMedia('(hover: none)').matches;
      var clamp = function (v) { return Math.max(-1, Math.min(1, v)); };
      function apply() {
        items.forEach(function (it) {
          var z = parseFloat(it.style.getPropertyValue('--z')) || 1;
          var amp = touch ? 8 : 16;
          var t = 'translate3d(' + (cx * amp * z).toFixed(2) + 'px,' + (cy * amp * 0.75 * z - sc * 26 * z).toFixed(2) + 'px,0)';
          if (it === hover) t += ' rotateX(' + (-hy * 9).toFixed(2) + 'deg) rotateY(' + (hx * 9).toFixed(2) + 'deg) scale(1.04)';
          it.style.transform = t;
        });
        if (amb) amb.style.transform = 'translate3d(' + (cx * (touch ? -10 : -22)).toFixed(2) + 'px,' + (cy * (touch ? -8 : -16)).toFixed(2) + 'px,0)';
      }
      function loop() {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        apply();
        if (Math.abs(tx - cx) > 0.002 || Math.abs(ty - cy) > 0.002) requestAnimationFrame(loop); else { cx = tx; cy = ty; apply(); running = false; }
      }
      function kick() { if (!running) { running = true; requestAnimationFrame(loop); } }
      function point(x, y) {
        var r = st.getBoundingClientRect();
        tx = clamp((x - r.left) / r.width * 2 - 1); ty = clamp((y - r.top) / r.height * 2 - 1);
        if (cur && !touch) { cur.style.transform = 'translate3d(' + (x - r.left) + 'px,' + (y - r.top) + 'px,0) translate(-50%,-50%)'; }
        if (hover) { var hr = hover.getBoundingClientRect(); hx = clamp((x - hr.left) / hr.width * 2 - 1); hy = clamp((y - hr.top) / hr.height * 2 - 1); }
        kick();
      }
      if (reduced) return;
      if (!touch) {
        on(st, 'pointermove', function (e) { point(e.clientX, e.clientY); });
        on(st, 'pointerenter', function () { st.classList.add('is-hover'); });
        on(st, 'pointerleave', function () { st.classList.remove('is-hover'); hover = null; tx = 0; ty = 0; kick(); });
        items.forEach(function (it) { on(it, 'pointerenter', function () { hover = it; }); on(it, 'pointerleave', function () { if (hover === it) hover = null; kick(); }); });
      } else {
        on(st, 'touchmove', function (e) { var t = e.touches[0]; if (t) point(t.clientX, t.clientY); }, { passive: true });
        on(st, 'touchend', function () { tx = 0; ty = 0; kick(); }, { passive: true });
        /* gyroscope where it needs no permission (Android); iOS silently keeps touch + scroll parallax */
        if (window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission !== 'function') {
          var base = null;
          on(window, 'deviceorientation', function (e) {
            if (e.gamma == null || e.beta == null) return;
            if (base === null) base = e.beta;
            tx = clamp(e.gamma / 28); ty = clamp((e.beta - base) / 28); kick();
          });
        }
      }
      var st2 = false;
      on(window, 'scroll', function () { if (st2) return; st2 = true; requestAnimationFrame(function () { st2 = false; var r = st.getBoundingClientRect(); sc = Math.max(0, Math.min(1, -r.top / (r.height || 1))); apply(); }); }, { passive: true });
    });
  }

  /* keep the dock, search sheet and floating buttons above the on-screen keyboard (phones) */
  if (window.visualViewport) {
    var vv = window.visualViewport, vvT = false;
    var vvUpdate = function () {
      var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      document.documentElement.style.setProperty('--kb', kb + 'px');
      document.documentElement.style.setProperty('--vvh', Math.round(vv.height) + 'px');
    };
    var vvSchedule = function () { if (!vvT) { vvT = true; requestAnimationFrame(function () { vvT = false; vvUpdate(); }); } };
    vv.addEventListener('resize', vvSchedule); vv.addEventListener('scroll', vvSchedule); vvUpdate();
  }

  function init(root) {
    root = root || document;
    Wish.paint();
    initImages(root); initReveal(root); initTabs(root); initReels(root); initProduct(root); initCollection(root); initWishlistPage(root); initRecent(root); initFloat(root);
  }

  on(document, 'shopify:section:load', function (e) { init(e.target); });
  on(document, 'shopify:section:select', function (e) { init(e.target); });

  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', function () { init(); }); else init();

  window.NS = { money: money, cardHTML: cardHTML, normalize: normalize, cart: Cart, wish: Wish, toast: toast, search: Search, init: init, setTheme: setTheme, img: img };
})();
